import "../assets/styles/views/login.scss";
import {
  user_login,
  user_mfa_active,  
} from "../utils/endpoints";
import { useOutletContext, NavLink } from "react-router-dom";
import PasswordField from "../components/PasswordField";
import { setCookie } from "../utils/cookie";
import { checkSession } from "../utils/session";
import { useAuth } from './../components/activeDirectory/AuthProvider';
import MicrosoftLogo from "../assets/icons/microsoft-logo";
import SignInButton from "../components/activeDirectory/SignInButton";

export default function Login() {
    const { token } = useAuth();
  const [context, setContext] = useOutletContext();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const obj = {
      email: e.target.email.value,
      password: e.target.password.value,
      tenantGuid: process.env.REACT_APP_GUID,
    };

    let response = await context.httpRequest("post", user_login, obj);

    if (!!response && response.result) {
      if (e.target.remember.checked) setCookie("remember_session", true);

      let auth_code_active = await context.httpRequest(
        "get",
        user_mfa_active,
        null,
        response.data.token
      );

      if (auth_code_active.result && auth_code_active.data.isActive) {
        context.navigateUrl("/auth-code", {
          state: { session: response.data, email: obj.email },
        });
      } else {
        setContext({ session: response.data });
        setCookie("session_cookie", JSON.stringify(response.data));
        checkSession(setContext, context.navigateUrl, context.httpRequest,token);
      }
    } else {
      if (!!response && !!response.error && !!response.error.errorMsg) {
        const expMessages = [
          "credenziali dell'utente scadute",
          "user credentials have expired",
          "les identifications de l\'utilisateur ont expiré"
        ]
        if (
          expMessages.includes(response.error.errorMsg.toLowerCase())
        ) {
          context.navigateUrl("/credentials-expired", {
            state: e.target.email.value,
          });
        }
      }
    }
  };

  return (
    <section className="login w-100 mt-md-5 main-panel p-3">
      <div className="d-flex align-items-center">
        <h1 className="m-0">Log In</h1>
        <NavLink to="/faq" className="ms-auto">
          FAQ
        </NavLink>
      </div>
      <small className="mt-3 d-block">Accedi all'area di formazione</small>
      <form onSubmit={(e) => handleSubmit(e)}>
        <label className="d-block mt-3">EMAIL / USERNAME</label>
        <input name="email" type="text" className="w-100" required />

        <label className="d-block mt-3">PASSWORD</label>
        <PasswordField name="password" required={true} check_format={false} />

        <div className="d-flex align-items-center mt-3">
          <input name="remember" type="checkbox" id="remember" />
          <label htmlFor="remember" className="ms-2">
            Ricordami
          </label>
          <NavLink
            className="ms-auto text-decoration-none"
            to="/password-recovery"
          >
            Password dimenticata?
          </NavLink>
        </div>
        <div className="d-flex gap-2 mt-3">
          <button className="mt-3 p-3 w-50 q8-blue-button" type="submit">
            <strong>ACCEDI</strong>
          </button>

          <NavLink
            className="mt-3 p-3 w-50 text-decoration-none q8-white-button text-center"
            to="/sign-in"
          >
            <strong>REGISTRATI</strong>
          </NavLink>
        </div>

        <div className="divider position-relative mt-5 mb-4">
          <div className="w-100"></div>
          <small className="position-absolute top-50 start-50 px-2">
            Oppure
          </small>
        </div>

        <div className="d-inline-flex align-items-center justify-content-center w-100">
          <MicrosoftLogo className="me-3" color="#20419a" size={26} />
          <SignInButton />
         
        </div>
      </form>
    </section>
  );
}
